import { CollapsibleTableInputs } from './CollapsibleTable';

export const collapsibleTableTransformer = (
    node: any
): CollapsibleTableInputs => {
    return {
        expandedByDefault: node.field_expanded_by_default,
        header: node.field_header,
        headerRight: node.field_header_right,
        quantityLabel: node.field_quantity_label,
        id: node.id,
        tableType: node.field_table_type?.toLowerCase(),
        subHeader: node.field_sub_header,
        subHeaderRight: node.field_sub_header_right,
        rows:
            node.relationships &&
            node.relationships.field_rows.map((row) => ({
                id: row.id,
                mainText: row.field_main_text,
                secondaryText: row.field_secondary_text,
                url: row.field_url,
                nestedRows: row.relationships?.field_collapsible_row_child,
            })),
    };
};
